<div class="text-xl font-bold mb-5">{{ 'ONB_CLIENT_LIST.ONBOARDING' | translate }}</div>

<div class="flex items-center justify-between mb-4">
  <h2 class="text-lg font-semibold">
    {{ 'ONB_CLIENT_LIST.INSTITUTE_LIST' | translate }}
  </h2>

  @if (isRelationshipOfficer) {
    <button
      class="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-semibold"
      (click)="openPopup()"
    >
      + {{ 'ONB_CLIENT_LIST.ADD_INSTITUTE' | translate }}
    </button>
  }
</div>

<app-popup
  [(show)]="showPopup"
  title="ONB_CLIENT_LIST.ADD_INSTITUTE"
  [fields]="clientFormFields"
  [data]="formData"
  [onSave]="handleSave"
  type="form"
></app-popup>

<app-table
  [columns]="columns"
  [data]="clients"
  [actions]="actions"
  [pageSize]="10"
  [enablePagination]="true"
></app-table>

<app-popup
  [(show)]="showClientActionPopup"
  title="ONB_CLIENT_LIST.INSTITUTE_ACTION"
  type="custom"
  width="w-full max-w-md"
>
  <div class="space-y-4">
    <p class="text-sm text-gray-600">
      {{ 'ONB_CLIENT_LIST.SELECT_ACTION_MSG' | translate }}
    </p>

    <label
      class="flex gap-3 p-4 border rounded-xl cursor-pointer"
      [ngClass]="
        selectedClientAction === 'sendBackToRO'
          ? 'border-indigo-500 bg-indigo-50'
          : 'border-gray-200'
      "
    >
      <input
        type="radio"
        name="clientAction"
        value="sendBackToRO"
        [(ngModel)]="selectedClientAction"
        class="mt-1"
      />

      <div>
        <p class="font-semibold text-slate-800">{{ 'ONB_CLIENT_LIST.SEND_BACK_TO_RO' | translate }}</p>

        <p class="text-sm text-gray-500 mt-1">
          {{ 'ONB_CLIENT_LIST.SEND_BACK_TO_RO_DESC' | translate }}
        </p>
      </div>
    </label>

    <label
      class="flex gap-3 p-4 border rounded-xl cursor-pointer"
      [ngClass]="
        selectedClientAction === 'reject'
          ? 'border-red-500 bg-red-50'
          : 'border-gray-200'
      "
    >
      <input
        type="radio"
        name="clientAction"
        value="reject"
        [(ngModel)]="selectedClientAction"
        class="mt-1"
      />

      <div>
        <p class="font-semibold text-red-700">{{ 'ONB_CLIENT_LIST.REJECT_INSTITUTE' | translate }}</p>

        <p class="text-sm text-gray-500 mt-1">
          {{ 'ONB_CLIENT_LIST.REJECT_INSTITUTE_DESC' | translate }}
        </p>
      </div>
    </label>

    <div class="flex justify-end gap-3 pt-3">
      <button
        class="btn-primary"
        [disabled]="isClientActionSubmitting"
        (click)="submitClientAction()"
      >
        {{ (isClientActionSubmitting ? 'ONB_CLIENT_LIST.PROCESSING' : 'ONB_CLIENT_LIST.SEND') | translate }}
      </button>

      <button
        class="btn-danger"
        [disabled]="isClientActionSubmitting"
        (click)="closeClientActionPopup()"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  </div>
</app-popup>